import { csvMappingDefinitionApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const CSV_MAPPINGS_DEFINITION_ACTION_TYPE = createNamedActions('csvMappingDefinition', {
  GET_CSV_MAPPING_DEFINITION: 'GET_CSV_MAPPING_DEFINITION',
  CREATE_CSV_MAPPING_DEFINITION: 'CREATE_CSV_MAPPING_DEFINITION',
  EDIT_CSV_MAPPING_DEFINITION: 'EDIT_CSV_MAPPING_DEFINITION',
  DELETE_CSV_MAPPING_DEFINITION: 'DELETE_CSV_MAPPING_DEFINITION',
});

const csvMappingsSchema = new schema.Entity('data', {}, { idAttribute: 'csvMappingDefinitionId' });

export const getCsvMappingDefinitionListAction = catchAsyncActionError(
  ({ companyId }) =>
    async dispatch => {
      const { data } = await csvMappingDefinitionApi.getCsvMappingDefinitionList({ companyId });

      return dispatch({
        type: CSV_MAPPINGS_DEFINITION_ACTION_TYPE.GET_CSV_MAPPING_DEFINITION,
        payload: normalize(data, [csvMappingsSchema]).entities.data,
      });
    },
);

export const createCsvMappingDefinitionAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await csvMappingDefinitionApi.createCsvMappingDefinition(params);

  return dispatch({
    type: CSV_MAPPINGS_DEFINITION_ACTION_TYPE.CREATE_CSV_MAPPING_DEFINITION,
    payload: data,
  });
});

export const editCsvMappingDefinitionAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await csvMappingDefinitionApi.editCsvMappingDefinition(params);

  return dispatch({
    type: CSV_MAPPINGS_DEFINITION_ACTION_TYPE.EDIT_CSV_MAPPING_DEFINITION,
    payload: data,
  });
});

export const deleteCsvMappingDefinitionAction = catchAsyncActionError(params => async dispatch => {
  await csvMappingDefinitionApi.deleteCsvMappingDefinition(params);

  return dispatch({
    type: CSV_MAPPINGS_DEFINITION_ACTION_TYPE.DELETE_CSV_MAPPING_DEFINITION,
    meta: params,
  });
});
